import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

  export const createTypeInspection = async (data) => {
      try {
        const response = await api.create(url.ADD_TYPE, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getTypeInspection = async () => {
      try {                                                                            
        const response = await api.get(url.GET_TYPE);
        return response;
      } catch (error) {
        throw error;
      }
  };
  

  export const updateTypeInspection = async ( id, data) => {
      try {
        const response = await axios.patch(url.UPDATE_TYPE +'/'+id, data);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getHistoryById = async (id) => {
    try {
      const response = await api.get(`/history/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
};

  export const deleteTypeInspection = async (id) => {
    try {
        const response = await api.delete(url.DELETE_TYPE +'/'+id);
        return response;
    } catch (error) {
        throw error;
    }
  };

